import React, { useState, useEffect } from "react";
import { Configurations } from "../../../Utils/Configurations";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import './Cile-Content.scss';
import axios from "axios";
import { withRouter } from 'react-router-dom';
import moment from "moment";

const CileContentVideosDetails = (props) => {

    const [loading, setLoading] = useState(false)
    const [livros, setLivros] = useState([])
    const [modalSuccess, setModalSuccess] = useState(false)

    const [formState, setFormState] = useState(props.location.state ? {
        titulo: props.location.state.titulo,
        descricao: props.location.state.descricao,
        youtube: props.location.state.youtube,
        vimeo: props.location.state.vimeo,
        livro: props.location.state.books_id,
    } : {
        titulo: '',
        descricao: '',
        youtube: '',
        vimeo: '',
        livro: ''
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        chamadaLivros()
    }, [])

    const chamadaLivros = () => {
        const config = new Configurations();
        axios.get(config.apiBasePath + `/conteudo-cile/livros/lista?limite=10&pagina=1`)
            .then(response => {
                setLivros(response.data.livros)
            })
            .catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() => {
                setLoading(false)
            });
    }

    const selectLivro = (id) => {
        console.log("Livro selecionado com id:", id);
        setFormState((prevState) => ({
            ...prevState,
            livro: id,
        }));
    };

    const EditarVideo = () => {
        const config = new Configurations();
        const _body = {
            "titulo": formState.titulo,
            "descricao": formState.descricao,
            "linkVimeo": formState.vimeo,
            "linkYoutube": formState.youtube,
        };

        axios.put(config.apiBasePath + `/conteudo-cile/videos/atualiza/${props.location.state.id}`, _body)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                setModalSuccess(true)
            )
    }

    const AdicionarVideo = () => {
        const config = new Configurations();
        const _body = {
            "titulo": formState.titulo,
            "descricao": formState.descricao,
            "linkVimeo": formState.vimeo,
            "linkYoutube": formState.youtube,
            "idLivro": formState.livro,
            "dtPublicacao": moment().format('YYYY-MM-DD'),
        };

        axios.post(config.apiBasePath + `/conteudo-cile/videos/novo`, _body)
            .then(() => {
                setLoading(true)

            }).catch(error => {
                console.log("ERROR: ", error)
            })
            .finally(() =>
                window.history.go(-1)
            )
    }

    const toggleModal = () => {
        setModalSuccess(!modalSuccess)
        window.history.go(-1)
    }

    const podeSalvar = () => {
 
        const tituloValido = !!formState.titulo 
         
        const descricaoValida = !!formState.descricao && formState.descricao.trim() !== "";

        const linkValido = (!!formState.vimeo && formState.vimeo.trim() !== "") ? (!!formState.vimeo && formState.vimeo.trim() !== "") : (!!formState.youtube && formState.youtube.trim() !== "");

        const livroValido = !!formState.livro

         
        const fluxoEdicao = !!props.location.state;
         
        if (fluxoEdicao) {
             return false
        }else {
            return !tituloValido || !descricaoValida || !linkValido || !livroValido
         }
        }

    return (
        <div className="cile-remessas">
            <div className="row">
                <div className="col-12 py-2">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            {props.location.state ?
                                <h2 className="title-1 d-none d-lg-block">CILE - Editar vídeo</h2>
                                :
                                <h2 className="title-1 d-none d-lg-block">CILE - Adicionar vídeo</h2>
                            }
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button onClick={() => window.history.go(-1)} className="btn btn-outline-secondary">voltar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="card">
                <div className="row no-gutters align-items-center px-3">
                    <div className='col-12 py-3'>
                        <label className="pl-2"><strong>Título do vídeo:</strong></label>
                        <input name="titulo" type="text" className="form-control" autoComplete="off" value={formState.titulo} onChange={handleInputChange} />
                    </div>
                    {props.location.state ? null :
                        <div className='col-5 py-3'>
                            <label className="pl-2"><strong>Livro:</strong></label>

                            <select
                                id="livro"
                                name="selectLivro"
                                className="form-control"
                                value={formState.livro}
                                onChange={(e) => selectLivro(e.target.value)}
                            >
                                <option value="" disabled hidden>Selecione um livro</option>
                                {livros && livros.length > 0 &&
                                    livros.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.title}
                                        </option>
                                    ))
                                }

                            </select>
                        </div>
                    }
                    <div className="col-12 py-3">
                        <label className="pl-2"><strong>Descrição:</strong></label>
                        <textarea name="descricao" rows={5} className="w-100 form-control" value={formState.descricao} onChange={handleInputChange} />
                    </div>

                    <div className='col-12 py-3'>
                        <label><strong>Link Vimeo:</strong></label>
                        <input name="vimeo" type="text" className="form-control" autoComplete="off" value={formState.vimeo} onChange={handleInputChange} />
                    </div>
                    <div className='col-12 py-3'>
                        <label><strong>Link YouTube:</strong></label>
                        <input name="youtube" type="text" className="form-control" autoComplete="off" value={formState.youtube} onChange={handleInputChange} />
                    </div>

                    <div className='col-12 text-right py-2'>
                        {loading ? <div className="spinner-border text-success" role="status" />
                            :
                            <button className='btn btn-outline-success' disabled={podeSalvar()} onClick={() => props.location.state ? EditarVideo() : AdicionarVideo()} >
                                {props.location.state ? 'Salvar' : 'Incluir'}
                            </button>
                        }

                    </div>
                    {/* )} */}

                </div>



            </div>

            <Modal isOpen={modalSuccess} toggle={toggleModal}>
                <ModalHeader>
                    Sucesso
                </ModalHeader>
                <ModalBody>
                    <div className='row'>
                        <div className='col-12'>
                            <p>{props.location.state ? 'Vídeo editado com sucesso!' : 'Vídeo adicionado com sucesso!'}</p>
                        </div>
                        <div className='col-12 text-right pt-2'>
                            <button className='btn btn-outline-success' onClick={() => window.history.go(-1)} >
                                Continuar
                            </button>
                        </div>

                    </div>

                </ModalBody>
            </Modal>


        </div>
    )
}


export default withRouter(CileContentVideosDetails);